@let entry = entrySg();

<div
  class="atn-file-finder-entry"
  [class.atn-file-finder-entry--last]="isLastSg()"
>
  <div class="atn-file-finder-entry__name">{{ entry.name }}</div>
  <i
    class="atn-file-finder-entry__download atn-icon atn-download atn-blue"
    title="Download file"
    (click)="download()"
  ></i>
</div>
